import { useMutation } from '@tanstack/react-query';
import type {
  WithdrawBankTransferBodyRequest,
  WithdrawBankTransferErrorResponse,
} from '@/features/withdraw-bank-transfer';
import type { WithdrawSuccessResponse } from '@/shared/types';
import { withdrawBankTransfer } from '../requests';

interface UseWithdrawBankTransferOptions {
  onSuccess?: (data: WithdrawSuccessResponse) => void;
  onError?: (error: WithdrawBankTransferErrorResponse) => void;
}

export function useWithdrawBankTransfer(
  options?: UseWithdrawBankTransferOptions
) {
  const mutation = useMutation<
    WithdrawSuccessResponse,
    WithdrawBankTransferErrorResponse,
    WithdrawBankTransferBodyRequest
  >({
    mutationFn: withdrawBankTransfer,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });

  return {
    ...mutation,
  };
}
